import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import ImageLoader from './../shared/ui/ImageLoader';
import ThemeLabel from './../shared/designElements/ThemeLabel';
import ProgressCircle from './../shared/designElements/ProgressCircle';
import ECWSpaceBlockHotspotOptions from './ECWSpaceBlockHotspotOptions';
import { fromBreakpoint } from '../../styles/breakpoints';
import { ECWthemeMap } from '../../styles/styleGuide';
var SpaceBlock = /*#__PURE__*/function (_Component) {
  function SpaceBlock() {
    var _this;
    _classCallCheck(this, SpaceBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpaceBlock, [].concat(args));
    _defineProperty(_this, "state", {
      maxHeight: 0
    });
    _defineProperty(_this, "calculateProgress", function (space) {
      var hotspots = space.hotspots;
      if (hotspots.length === 0) return 0;
      return hotspots.filter(function (hotspot) {
        return hotspot.hasRating;
      }).length / hotspots.length;
    });
    _defineProperty(_this, "setMaxHeight", function (maxHeight) {
      _this.setState({
        maxHeight: maxHeight
      });
    });
    _defineProperty(_this, "toggleShow", function () {
      _this.props.onToggle(_this.props.space.id);
    });
    return _this;
  }
  _inherits(SpaceBlock, _Component);
  return _createClass(SpaceBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        index = _this$props.index,
        space = _this$props.space,
        isOpen = _this$props.isOpen;
      return __jsx(Container, {
        "data-id": "dashboard_ECWSpaceBlock_Container"
      }, __jsx(SpaceContainer, {
        index: index,
        onClick: this.toggleShow,
        "data-id": "dashboard_ECWSpaceBlock_SpaceContainer"
      }, __jsx(ImageLoader, {
        src: '/images/interestsimage.jpg',
        mode: "img",
        alt: "interestsimage",
        "data-id": "dashboard_ECWSpaceBlock_ImageLoader"
      }), __jsx(Progress, {
        "data-id": "dashboard_ECWSpaceBlock_Progress"
      }, __jsx(ProgressCircle, {
        theme: ECWthemeMap[space.theme.slug],
        progress: this.calculateProgress(space),
        "data-id": "dashboard_ECWSpaceBlock_ProgressCircle"
      })), __jsx(Label, {
        show: isOpen,
        "data-id": "dashboard_ECWSpaceBlock_Label"
      }, __jsx(ThemeLabel, {
        twoTriangles: true,
        label: space.title,
        theme: ECWthemeMap[space.theme.slug],
        "data-id": "dashboard_ECWSpaceBlock_ThemeLabel"
      }))), __jsx(FoldContainer, {
        show: isOpen,
        maxHeight: this.state.maxHeight,
        "data-id": "dashboard_ECWSpaceBlock_FoldContainer"
      }, isOpen && __jsx(ECWSpaceBlockHotspotOptions, {
        index: index,
        show: isOpen,
        options: space.hotspots,
        theme: ECWthemeMap[space.theme.slug],
        maxHeight: this.state.maxHeight,
        onMeasureHeight: this.setMaxHeight,
        "data-id": "dashboard_ECWSpaceBlock_ECWSpaceBlockHotspotOptions"
      })));
    }
  }]);
}(Component);
export default SpaceBlock;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var SpaceContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 290rem;\n  height: 180rem;\n  margin-top: 20rem;\n  cursor: pointer;\n  ", ";\n"])), fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-left: ", "rem;\n  "])), function (props) {
  return props.index % 2 === 1 ? 20 : 0;
}));
var FoldContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: ", "rem;\n  opacity: ", ";\n  transition: margin 0.3s ease-in-out, opacity 0.25s ease-in-out;\n"])), function (props) {
  return props.show ? props.maxHeight + 20 : 0;
}, function (props) {
  return props.show ? 1 : 0;
});
var Progress = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 12rem;\n  right: 12rem;\n  z-index: 2;\n"])));
var Label = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: ", "rem;\n  z-index: 2;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  transition: bottom 0.3s ease-in-out;\n\n  > div > span {\n    width: 180rem;\n    padding: 0 15rem;\n    justify-content: center;\n  }\n"])), function (props) {
  return props.show ? -20 : 0;
});